import { useTLang } from 'intl/intl';

import { MOZART_COMPLAINT_REASON } from 'features/mozart-notifications/domain';

export function useMozartDialogsLang() {
  const REASON_WARNING = MOZART_COMPLAINT_REASON.DEFECT_WARNING;
  const REASON_GROUNDED = MOZART_COMPLAINT_REASON.DEFECT_GROUNDED;
  return {
    action: {
      primary: {
        [REASON_WARNING]: useTLang({ id: 'notification.mozart.043' }),
        [REASON_GROUNDED]: useTLang({ id: 'notification.mozart.039' }),
      },
      secondary: {
        [REASON_WARNING]: useTLang({ id: 'notification.mozart.039' }),
        [REASON_GROUNDED]: '',
      },
    },
  };
}
